export default __webpack_public_path__ + "static/media/grid.003.f6a89e62.jpeg";